import React, { useState, useEffect } from "react";
import classes from "./login.module.css";
import Input from "./Input";
import Button from "./button";
import Link from "./link";
import axios from "../../Axios";

import Validation from "../utils/validation";
import { notification} from "antd";
import { useHistory } from "react-router-dom";

const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: `${message}`,
    description: `${description}`,
  });
};

const intialState = {
  email: null,
  password: null,
  company: null,
  name: null,
  tel: null,
};

const initialError = {
  email: false,
  password: false,
  company: false,

  name: false,
  tel: false,
};
const Register = ({ setAuth }) => {
  const history = useHistory();
  const [state, setState] = useState({ ...intialState });
  const [errors, setErrors] = useState({ ...initialError });
  const [loading, setLoading] = useState(false);
  const { email, password, company, name, tel } = state;

  const [isInValid, setIsInValid] = useState(false);

  useEffect(() => {
    //err handeling

    if (
      email === null ||
      password === null ||
      company === null ||
      name == null ||
      tel == null ||
      errors.email ||
      errors.password ||
      errors.company ||
      errors.name ||
      errors.tel
    ) {
      setIsInValid(true);
    } else setIsInValid(false);
  }, [state, errors, email, password, company, name, tel]);

  const clickHandler = (e) => {
    e.preventDefault();
    setLoading(true)
    axios.post("/admin/signup", state).then((res) => {
      setLoading(false);
      const { data } = res;
      if (data.error) {
        openNotificationWithIcon(
          "error",
          "Registration Failed",
          `Registration failed due to ${data.message}`
        );
      } else if (data.auth) {
        localStorage.setItem("currentEmail", email);
        openNotificationWithIcon(
          "success",
          "OTP",
          `An OTP has been sent to ${email}. Enter OTP to get verified`
        );
        history.push("/verify");
      } else {
        openNotificationWithIcon(
          "error",
          "Registration Failed",
          `Registration failed due to ${data.message}`
        );
      }

    }).catch((err)=>{
      setLoading(false);
      openNotificationWithIcon(
        "error",
        "Registration Failed",
        `Registration failed due to ${err}`
      );

    });

  };

  const changeHandler = (e) => {
    let { name, value } = e.target;
    let inputValid = false;
    if (name === "email") {
      if (Validation().email(value)) inputValid = true;
    } else if (name === "password") {
      if (Validation().passwordOnLog(value)) inputValid = true;
    } else {
      if (value.length > 0) inputValid = true;
    }
    setErrors(() => ({ ...errors, [name]: !inputValid }));
    if (value === "") value = null;

    setState(() => ({ ...state, [name]: value }));
  };

  return (
    <>
      <h1 className={classes.login}>Register</h1>
      <span className={classes.text}>To Hassle Free Paperless Audits</span>

      <Input
        onChange={changeHandler}
        name="name"
        value={name?name:''}
        type="text"
        err={errors["name"]}
        errMsg="This a Mandatory Field"
        HolderClass={classes.input}
        placeholder="name"
      />
      <Input
        onChange={changeHandler}
        name="email"
        value={email?email:''}
        err={errors["email"]}
        errMsg="Please enter a valid email address"
        type="email"
        HolderClass={classes.input}
        placeholder="e-mail"
      />
      <Input
        onChange={changeHandler}
        err={errors["company"]}
        errMsg="This a Mandatory Field"
        name="company"

        value={company}
        type="text"

        HolderClass={classes.input}
        placeholder="company/organization"
      />
      <Input
        onChange={changeHandler}
        name="tel"
        err={errors["tel"]}
        errMsg="This a Mandatory Field"
        value={tel?tel:''}
        type="tel"
        HolderClass={classes.input}
        placeholder="phone no."
      />
      <Input
        onChange={changeHandler}
        name="password"
        value={password?password:''}
        errMsg="Length of password must be 5"
        err={errors["password"]}
        type="password"
        HolderClass={classes.input}
        placeholder="password"
      />

      <Button
        onClick={clickHandler}
        disabled={isInValid}
        extraClass={classes.button}
        isLoading={loading}
      >
        Continue
      </Button>

      <div className={classes.block}>
        <span className={classes.span}>Already a member ?</span>
        <Link
          extraClass={[classes.link, classes.linkTwo].join(" ")}
          href="/login"
        >
          {" "}
          Sign in
        </Link>
      </div>
    </>
  );
};

export default Register;
